export const arTexts = {
  // Titles
  encyclopediaTitle: "موسوعة",
  insuranceAndServicesTitle: "للتأمين والخدمات",
  generatorTitle: "مولدات",

  home: "الصفحة الرئيسية",
  menu: "منو",
  contactUs: "اتصل بنا",
  loginRegister: "دخولتسجيل",
  encyclopedia: "موسوعة",
  vr: "الواقع الافتراضي",
  buy: "يشترى",
  loading: "جار التحميل",
  rugGenerate: "تنسيق السجادة",
  insuranceAndServices: "التأمين والخدمات",
  insurance: "تأمين",
  brand: "العلامة التجارية",
  shaneh: "القصب",
  density: "كثافة",
  yarn: "غزل",
  rug_size_6: "حجم السجادة 6",
  rug_size_9: "حجم السجادة 9",
  rug_size_12: "حجم السجادة 12",
  decoration: "زخرفة",
  room_services: "خدمات:",
  floor_covering: "أرضية",
  wall: "حائط",
  roof: "سقف",
  selectImage: "اختر صورة",
  wishListText:
    "يمكنك إضافة السجاد الذي تم إنشاؤه إلى قائمة المفضلة لمشاهدة معاينة لهم لاحقًا",
  services: "خدمات",
  specialPosts: "الوظائف الخاصة",
  preview: "معاينة",
  lachakToranj: "لاتشاك تورانج",
  modern: "عصري",
  afshan: "أفشان",
  kheshti: "خشتي",
  your_picture: "التصویر",
  border: "الحدود",
  corner: "ركن",
  background: "خلفية",
  toranj: "تورانج",
  tile: "بلاط",
  pattern: "نمط",
  rugSettings: "بلاط",
  wishList: "قائمة الرغبات",
  addToWishList: "أضف إلى قائمة الامنيات",
  listIsEmpty: "القائمة فارغة",
  rotate: "استدارة",
  clear: "واضح",
  latest: "آخر",
  oldest: "الأقدم",
  onSale: "للبيع",
  searchingForSellers: "البحث عن البائعين",
  storesForThisRug: "مخازن لهذه البساط",
  noStoreForSelectedRug: "لا يوجد متجر للسجاد المحدد",
  selectOneSimilarRug: "حدد سجادة واحدة مماثلة",
  selectedRugs: "السجاد المختار",
  rugSimilarityPercentage: "النسبة المئوية لتشابه البساط",
  similarRugs: "سجاد مماثلة",
  availableRugSizes: "مقاسات البساط المتوفرة",
  phoneNumber: "رقم الهاتف",
  address: "عنوان",
  filters: "عوامل التصفية",
  filter: "عوامل",
  previewEmptyHelpText: "معاينة نص التعليمات الفارغ",
  camera: "دوربین",
  upload: "بارگذاری",
  selectSizeYourPic: "اندازه فرش",
  // Texts

  landingText: `يعد خلق قيمة مضافة لعملية الشراء أحد الاهتمامات الرئيسية لأي عمل تجاري. يمكن فحص هذه القيمة المضافة والعمل على أساسها بثلاث طرق. من وجهة نظر المستهلك ، البائع والمنتج في النهاية ، هدف غاليشين هو خلق هذه القيمة المضافة في منصة رقمية وآمنة. نهجنا هو عرض بيع وشراء"سلع السجاد" في بيئة جديدة وموثوقة`,
  wikipediaBoldText: `ما هو الفرق بين السجاد المصنوع آليًا والسجاد اليدوي؟ ما الذي يجب علي الانتباه إليه عند اختيار سجادة عالية الجودة؟ كيف اختار مقاس السجادة؟ ما هو لون السجاد المناسب لديكورتي؟ ماذا يعني المشط والكثافة في سجادة السيارة؟ ماذا يعني راج في عقد اليد؟`,
  wikipediaLightText: `المعلومات الكافية قبل الشراء هي أحد متطلبات شراء أي منتج. يسعى غاليشين في قسم الموسوعات إلى الإجابة عن أسئلتك وتقديم أدق المعلومات حول المواد والتصميم والأناقة والألياف واللون والأبعاد وتصميم السجاد والبساط`,
  layOutBoldText: `كيف كانت سجادة جاري؟ هل توافق على أن خلفية سجادته كانت مشابهة جدًا لديكور منزلنا؟أتمنى أن أتمكن من رؤية تفاصيل السجاد بعناية دون التجول في السوق من المنزل وعدم إزعاج البائعين`,

  layOutLightText: ` تخطيط السجاد هو خدمتنا الخاصة والحصرية لمن يهتم باللعب بتفاصيل سجادته والعثور على أقرب سجادة من اختيارهم وتجهيزها من أقرب سجادة لحل محل إقامتهم`,
  VRBoldText: `أتمنى أن نقول أحضر جميع السجاد الأربعة إلى المنزل وسنختار واحدة. هل تتناسب السجادة الحديثة مع ديكورنا أكثر أم التقليدية؟ هل ستكون السجادة على الباركيه جيدة؟`,

  VRLightText: `ربما حدث لك أنك عند شرائك للسجاد تعجبك بعض التصميمات ، لكن لا يمكنك نشر كل هذه السجاد في منزلك ورؤية مظهرها مع ديكور منزلك واختيار الخيار الأفضل. لديه العديد من الأفكار لهذه الحاجة لك. محاكاة منزلك هي بداية هذا المسار وستستمر`,
  shoppingBoldText: `هل تعرف من الذي تشتري؟ هل يمكن الوثوق بها ، أليس هذا خدعة ، هل يرسلون السجادة؟ أليس من الأفضل الشراء شخصيًا؟`,
  shoppingLightText: `لطالما كان إنشاء منصة آمنة للتجارة مصدر قلق للمستهلكين والبائعين. تعد الثقة في بيئة المبيعات عبر الإنترنت أكثر تعقيدًا بكثير ، وهذا أحد العقبات التي تحول دون توسع هذا السوق ، خاصة بالنسبة للمنتجات القيمة. حاول Galichin توفير منصة مبيعات آمنة وموثوقة لشراء السجاد للمستهلكين وبيع السجاد للموردين من خلال إنشاء آليات مناسبة`,
  insuranceBoldText: `أتمنى أن يقوم البائع بغسل السجاد بشكل دوري؟ أين يمكنني غسل السجادة حتى لا تفسد؟ أتمنى أن يأخذوا سجادتنا القديمة ويستبدلونها بأخرى جديدة مقابل مبلغ معين!هل يوجد مكان يمكنني استئجار سجادة فيه؟ هل يستأجرون سجادًا جديدًا؟`,

  insuranceLightText: `خدمة ما بعد البيع وضمان السلع القيمة مثل السجاد ستجعل التسوق أكثر متعة وأمانًا لكل عميل. وفقًا لاحتياجات العملاء ، مع تقديم خدمات ما بعد البيع المختلفة ، تقدم غاليشين خدمات أخرى قيّمة. خدمات مثل الغسيل المجاني! استبدل سجادتك القديمة بأخرى جديدة! وخدمة تأجير السجاد لاستخدامك قصير الأمد للسجاد !!!`,

  insuranceText: `نحن مهتمون جميعًا بالشراء من مكان يقدم لنا أفضل الخيارات عند الشراء ووقت خدمة ما بعد البيع. كما يقدم غاليشين خدمات متنوعة في هذا الصدد. على سبيل المثال ، المستهلك. الشخص الذي اشترى يمكن للسجادة من غاليشن مع التأمين الاستفادة من أول غسل مجاني لسجادته أو بعد فترة سيحصل على سجادة جديدة بدفع جزء من التكلفة ، خدمة تأجير السجاد هي خدمة أخرى سيتم إطلاقها قريباً`,

  servicesText: `نحن مهتمون جميعًا بالشراء من مكان يقدم لنا أفضل الخيارات عند الشراء ووقت خدمة ما بعد البيع. كما يقدم غاليشين خدمات متنوعة في هذا الصدد. على سبيل المثال ، المستهلك. الشخص الذي اشترى يمكن للسجادة من غاليشن مع التأمين الاستفادة من أول غسل مجاني لسجادته أو بعد فترة سيحصل على سجادة جديدة بدفع جزء من التكلفة ، خدمة تأجير السجاد هي خدمة أخرى سيتم إطلاقها قريباً`,

  Custom_Your_Carpet: "طراحی فرش سفارشی",
  image_registration: "ثبت تصویر",
  zoom: "بزرگنمایی",
  confirmation_and_approval: "تایید و ادامه",
  name_and_lastname: "نام و نام خانوادگی",
  Phone_call: "تلفن تماس",
  Address: "آدرس",
  send: "ارسال",
  ordering: "مرتب سازی",
  carpet_show: "نمایش فرش",
  back_market: "بازگشت به بازار",
  next: "بعدی",
  previous: "قبلی",
  carpet_link: "لینک فرش مورد نظرتان",
  national_Code: "کد ملی",
  upload_photo_and_video: "آپلود عکس و ویدیو از فرش خودتان",
  photoـorـvideoـlink: "لینک عکس یا فیلم",
  coming_back: "بازگشت",
  the_link_of_the_carpet_you_want: "لینک فرش مورد نظرتان",
  landing_tab: "برای معرفی کامل هر بخش از منو بالا و همچنین برای دسترسی سریعتر از منو پایین پایین استفاده کنید.",
  carpet_replacement: "تعویض فرش",
  submit: "ارسال",
  receiving_information: "در حال دریافت اطلاعات",
  // login form
  login_register_tab_login: "ورود",
  login_register_tab_register: "ثبت نام",
  login_register_input_email: "ایمیل",
  login_register_input_password: "رمز عبور",
  login_register_input_repassword: "تکرار رمز عبور",
  login_register_btn_close: "بستن",
  login_register_btn_submit_login: "ورود",
  login_register_btn_submit_register: "ثبت نام",
  login_register_btn_exit: "خروج",
  order_input_command: "توضیحات",
  order_btn_submit: "ثبت نهایی",
  preview_btn_open_file_dialog: "بارگزاری تصویر پس‌زمینه",
  preview_btn_show_3d: "سه بعدی",
  preview_btn_totate: "افقی",
  preview_slider_prespective: "پرسپکتیو",
  preview_slider_size: "اندازه",
  preview_slider_angle_up_down: "زاویه بالا و پایین",
  preview_slider_angle_left_right: "زاویه چپ و راست",
  preview_slider_rotate: "چرخش",
  profile_btn: "Profile",
  profile_txt_first_name: "First Name",
  profile_txt_last_name: "Last Name",
  profile_txt_phone_number: "Phone Number",
};
